import { createUseStyles } from 'react-jss'
import MediaQueries from '../../../styles/MediaQueries'

export interface UseStylesProps {
  backgroundImageUrl: string
  mobileBackgroundImageUrl: string
}

const useStyles = createUseStyles({
  desktop: {
    display: 'none'
  },
  mobile: {
    display: 'block'
  },
  blurredBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: -1,
    filter: 'blur(10px)'
  },

  responsiveImage: {
    overflowY: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
  },

  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },

  [MediaQueries.Tablet]: {
    desktop: {
      display: 'block'
    },
    mobile: {
      display: 'none'
    },
    responsiveImage: {
    '& > img': {
      width: '100%',
      maxWidth: '1920px',
      height: 'auto'
    }
  }}
})

export default useStyles
